/* tslint:disable */

declare var Object: any;
export interface InspectionReportInterface {
  "inspectorId"?: string;
  "pictures"?: any;
  "procedureType"?: string;
  "certificationData"?: any;
  "imageRecognitionData"?: any;
  "inspectionForm"?: any;
  "agentCode"?: string;
  "licencePlate"?: string;
  "clientName"?: string;
  "vehicleType"?: string;
  "transactionId"?: string;
  "tokenId"?: string;
  "province"?: string;
  "date"?: Date;
  "ttl"?: number;
  "creationDateReport"?: Date;
  "expirationDate"?: Date;
  "id"?: any;
}

export class InspectionReport implements InspectionReportInterface {
  "inspectorId": string;
  "pictures": any;
  "procedureType": string;
  "certificationData": any;
  "imageRecognitionData": any;
  "inspectionForm": any;
  "agentCode": string;
  "licencePlate": string;
  "clientName": string;
  "vehicleType": string;
  "transactionId": string;
  "tokenId": string;
  "province": string;
  "date": Date;
  "ttl": number;
  "creationDateReport": Date;
  "expirationDate": Date;
  "id": any;
  constructor(data?: InspectionReportInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `InspectionReport`.
   */
  public static getModelName() {
    return "InspectionReport";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of InspectionReport for dynamic purposes.
  **/
  public static factory(data: InspectionReportInterface): InspectionReport{
    return new InspectionReport(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'InspectionReport',
      plural: 'InspectionReports',
      path: 'InspectionReports',
      idName: 'id',
      properties: {
        "inspectorId": {
          name: 'inspectorId',
          type: 'string'
        },
        "pictures": {
          name: 'pictures',
          type: 'any'
        },
        "procedureType": {
          name: 'procedureType',
          type: 'string'
        },
        "certificationData": {
          name: 'certificationData',
          type: 'any'
        },
        "imageRecognitionData": {
          name: 'imageRecognitionData',
          type: 'any'
        },
        "inspectionForm": {
          name: 'inspectionForm',
          type: 'any'
        },
        "agentCode": {
          name: 'agentCode',
          type: 'string'
        },
        "licencePlate": {
          name: 'licencePlate',
          type: 'string'
        },
        "clientName": {
          name: 'clientName',
          type: 'string'
        },
        "vehicleType": {
          name: 'vehicleType',
          type: 'string'
        },
        "transactionId": {
          name: 'transactionId',
          type: 'string'
        },
        "tokenId": {
          name: 'tokenId',
          type: 'string'
        },
        "province": {
          name: 'province',
          type: 'string'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "ttl": {
          name: 'ttl',
          type: 'number'
        },
        "creationDateReport": {
          name: 'creationDateReport',
          type: 'Date'
        },
        "expirationDate": {
          name: 'expirationDate',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'any'
        },
      },
      relations: {
      }
    }
  }
}
